import { render, staticRenderFns } from "./notifications.vue?vue&type=template&id=1003f21e&scoped=true"
import script from "./notifications.vue?vue&type=script&lang=js"
export * from "./notifications.vue?vue&type=script&lang=js"
import style0 from "./notifications.vue?vue&type=style&index=0&id=1003f21e&prod&scoped=true&lang=css"
import style1 from "./notifications.vue?vue&type=style&index=1&id=1003f21e&prod&lang=css"
import style2 from "./notifications.vue?vue&type=style&index=2&id=1003f21e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1003f21e",
  null
  
)

export default component.exports